import { createContext as e } from "react";
//#region src/services/telemetry/telemetry.tsx
var t = /* @__PURE__ */ function(e) {
	return e[e.default = 0] = "default", e[e.off = 1] = "off", e[e.error = 2] = "error", e[e.all = 3] = "all", e;
}({}), n = e(0);
//#endregion
export { t as TelemetryLevel, n as TelemetryLevelContext };
